import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const ATTRIBUTE_DELETE_RESOURCE = "app-role-attribute" as const;
export const ATTRIBUTE_DELETE_API_PATH = `/v1/${ATTRIBUTE_DELETE_RESOURCE}/{uuid}` as const;

export type AttributeResponse =
  paths[typeof ATTRIBUTE_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useAttributeDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AttributeResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.delete<AttributeResponse>(`/v1/${ATTRIBUTE_DELETE_RESOURCE}/${uuid}`);
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [ATTRIBUTE_DELETE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: ["app-role"],
        }),
      ]);
    },
  });
};
